import { numberOptionalSchema, numberRequiredSchema, select2RequiredSchema, stringOptionalSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { number, object } from 'yup';

const addAppointmentSchema = object().shape({
    client_type: select2RequiredSchema,
    client_id: select2RequiredSchema,
    parent_id: select2RequiredSchema,
    title: stringRequiredSchema,
    description: stringRequiredSchema,
    additonal_notes: stringOptionalSchema,
    location: select2RequiredSchema,
    location_notes: stringOptionalSchema,
    location_detail: stringOptionalSchema,
    appointment_type: select2RequiredSchema,
    price: number().when('appointment_type', {
        is: (appointment_type) => appointment_type?.value === "paid",
        then: () => numberRequiredSchema,
        otherwise: () => numberOptionalSchema,
    }),
    appointment_date: stringRequiredSchema,
    appointment_reason: stringRequiredSchema,
    slot: select2RequiredSchema
});

export default addAppointmentSchema;